import React, { useRef } from 'react';
import { Flex } from '@balance-web/flex';

import { useRecaptcha } from './useRecaptcha';

export type RecaptchaProps = {
  /**
   * Requires a valid recaptcha api key
   *
   * @see {@link [APPLICATION_CAPTCHA_SITE_KEY](../../../next.config.js)}
   */
  sitekey: string;
  onTokenChange: (token?: string) => void;
};

export function Recaptcha({ sitekey, onTokenChange }: RecaptchaProps) {
  const captchaRef = useRef<HTMLDivElement>(null);
  useRecaptcha({
    containerRef: captchaRef,
    onSuccess: (token) => {
      onTokenChange(token);
    },
    onError: () => {
      onTokenChange();
    },
    onExpired: () => {
      onTokenChange();
    },
    sitekey,
    badge: 'inline',
    size: 'normal',
  });

  return <Flex ref={captchaRef} justifyContent="center" />;
}
